var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4019 13.7116C7.5 13.4999 1.89127 19.8582 1.89127 19.8582V27.4232L3.78252 29.7873H27.4232L29.7872 28.3689V22.2223C29.7872 22.2223 24.8901 16.5971 22.695 16.5485C20.5 16.4999 17.9669 19.8582 17.9669 19.8582C17.9669 19.8582 13.3038 13.9234 10.4019 13.7116Z",
    fill: "#8B9FCD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.6,
    width: 28.8,
    height: 28.8,
    rx: 3.4,
    stroke: "#8B9FCD",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1473 6.83631C17.5438 6.57135 18.01 6.42992 18.4869 6.42992C19.1265 6.42992 19.7398 6.68398 20.192 7.13619C20.6442 7.58841 20.8983 8.20174 20.8983 8.84127C20.8983 9.31819 20.7569 9.7844 20.4919 10.1809C20.2269 10.5775 19.8503 10.8866 19.4097 11.0691C18.9691 11.2516 18.4843 11.2993 18.0165 11.2063C17.5488 11.1132 17.1191 10.8836 16.7819 10.5464C16.4446 10.2091 16.215 9.77946 16.1219 9.3117C16.0289 8.84395 16.0766 8.35911 16.2591 7.91849C16.4417 7.47787 16.7507 7.10127 17.1473 6.83631Z",
    fill: "#8B9FCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img-icon.04286a9f4254f0c1282761c33cccd773.svg";
export { ForwardRef as ReactComponent };